import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-our-digital-signage',
  templateUrl: './our-digital-signage.component.html',
  styleUrls: ['./our-digital-signage.component.scss']
})
export class OurDigitalSignageComponent implements OnInit {
  public iFrameSrcSafeChannel1: any = null;
  public iFrameSrcSafeChannel2: any = null;
  public iFrameSrcSafeChannel3: any = null;
  defaultChannelId: string;
  public companyId = '000001';

  constructor(
    public sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {

    this.defaultChannelId = 'M7i2gL8Jx2AMEEI2x9Ov';
    let src = this.sanitizer.bypassSecurityTrustResourceUrl( 'https://admirintegrated.web.app/simulator?companyId=' + this.companyId + '&channelId=' + this.defaultChannelId + '&mode=false');
    this.iFrameSrcSafeChannel1 = src;

    this.defaultChannelId = 'yAKWKzOlKUGpY4q4LdcP';
    src = this.sanitizer.bypassSecurityTrustResourceUrl( 'https://admirintegrated.web.app/simulator?companyId=' + this.companyId + '&channelId=' + this.defaultChannelId + '&mode=false');
    this.iFrameSrcSafeChannel2 = src;

    this.defaultChannelId = 'bqb3lEZlLAa4xW6288eS';
    src = this.sanitizer.bypassSecurityTrustResourceUrl( 'https://admirintegrated.web.app/simulator?companyId=' + this.companyId + '&channelId=' + this.defaultChannelId + '&mode=false');
    this.iFrameSrcSafeChannel3 = src;




  }

}
